// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import './MainMenuGroup.scss'


interface MainMenuGroupProps {
  children?: React.ReactElement | React.ReactNode | never[]
  title?: string
  visible?: boolean
}

const MainMenuGroup: React.FC<MainMenuGroupProps> = ({
  children,
  title,
  visible
}) => {
  if (!children) {
    return null
  }
  if (visible !== undefined && !visible) {
    return null
  }
  return (
    <div className="group">
      {(!!title) ? (<div className="heading">{title}</div>) : null}
      <div className="items">
        {children}
      </div>
    </div>
  )
}

export default MainMenuGroup